import React from 'react'
import theme from '../../styled/theme'
import { Button } from '../ui/button'
import { SadFace } from '../../assets/icons'
import { EmptyStateText, EmptyStateDiv } from './styled'
import { Text1, Text2 } from '../ui/text'

const EmptyState = ({ actionButton=true, isSearch }) => {
	const emptyContent = isSearch && !actionButton
		? {
			icon: <SadFace />,
			title: 'No tenemos resultados para vos',
			subtitle: 'Por favor, volvé a intentar con una nueva búsqueda.',
			action: null
		}
		: isSearch && actionButton
			? {
				icon: <SadFace />,
				title: 'No tenemos resultados para vos',
				subtitle: 'Por favor, volvé a intentar con una nueva búsqueda.',
			action: (
				<Button label="Ver todos los resultados" $variant="primary" onClick={actionButton} />
			)
			}
		: {
			icon: null,
			title: 'No tenés resultados',
			subtitle: 'Cuando tengas alguno, lo vas a ver acá.',
			action: null
		}
	return (
		<EmptyStateDiv>
			{emptyContent.icon}
			<EmptyStateText>
				<Text1 color={theme.colors.text.primaryText}>{emptyContent.title}</Text1>
				<Text2 color={theme.colors.text.secondaryText}>{emptyContent.subtitle}</Text2>
			</EmptyStateText>
			{emptyContent.action}
		</EmptyStateDiv>
	)
}

export default EmptyState
